<coso-grid [gridOptions]="gridOptions" [columnDefs]="columnDefs" [rowData]="rowData" aria-label="{{ caption }}"></coso-grid>

<ng-template #type let-params="params">
  <div class="text-center">
    @switch (params.data.actionType) {
      @case (ActionType.DEBUG) {
        <i class="fa fa-fw fa-bug" title="Debug" aria-hidden="true"></i><span class="sr-only">Debug</span>
      }
      @case (ActionType.INFO) {
        <i class="fa fa-fw fa-info-circle" title="Information" aria-hidden="true"></i><span class="sr-only">Information</span>
      }
      @case (ActionType.WARN) {
        <i class="fa fa-fw fa-exclamation-triangle" title="Warning" aria-hidden="true"></i><span class="sr-only">Warning</span>
      }
      @case (ActionType.ERROR) {
        <i class="fa fa-fw fa-times-circle" title="Error" aria-hidden="true"></i><span class="sr-only">Error</span>
      }
      @case (ActionType.EVENT) {
        <i class="fa fa-fw fa-bolt" title="Dynamics 365 Event" aria-hidden="true"></i><span class="sr-only">Dynamics 365 Event</span>
      }
      @case (ActionType.PERMISSION_WRITE) {
        <i class="fa fa-fw fa-pencil" title="Permission Write" aria-hidden="true"></i><span class="sr-only">Permission Write</span>
      }
    }
  </div>
</ng-template>

<ng-template #timestamp let-params="params">
  {{ (params.value | date: "MMM d, y HH:mm:ss":"UTC") }}
</ng-template>

<ng-template #additionalInfo let-params="params">
  <coso-resizable-text [text]="params.value ? params.value : '-'" />
</ng-template>
